import hres35uLabels from 'assets/labels/hres35u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres35uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        dtemov: moment().format('DD/MM/YYYY'),
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        codappr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codcomp1: faker.finance.currencyCode(),
      codcomp2: faker.finance.currencyCode(),
      codcomp3: faker.finance.currencyCode(),
      codcomp4: faker.finance.currencyCode(),
      codcomp5: faker.finance.currencyCode(),
      codcomp6: faker.finance.currencyCode(),
      codcomp7: faker.finance.currencyCode(),
      desc_codcomp: faker.company.companyName(),
      desc_codpos: faker.name.title(),
      desc_codjob: faker.name.jobTitle(),
      desc_codbrlc: faker.lorem.words(),
      codcom1: faker.finance.currencyCode(),
      codcom2: faker.finance.currencyCode(),
      codcom3: faker.finance.currencyCode(),
      codcom4: faker.finance.currencyCode(),
      codcom5: faker.finance.currencyCode(),
      codcom6: faker.finance.currencyCode(),
      codcom7: faker.finance.currencyCode(),
      desc_codcomp2: faker.company.companyName(),
      desc_codpos2: faker.name.title(),
      desc_codjob2: faker.name.jobTitle(),
      desc_codbrlc2: faker.lorem.words(),
      descreq1: faker.lorem.words()
    }

    return {
      tab1: mockTab1
    }
  },
  dropdowns () {
    const mockCodmov = {
      '0009': '0009 - ปรับตำแหน่ง',
      '0010': '0010 - ปรับระดับ',
      '0011': '0011 - เลื่อนระดับ/ปรับตำแหน่ง',
      '0012': '0012 - แต่งตั้ง/เลื่อนระดับ',
      '0013': '0013 - โอนย้าย',
      '0014': '0014 - รักษาการณ์/ควบตำแหน่ง',
      '0022': '0022 - czvcv',
      '0023': '0023 - xxx',
      '005X': '005X - ย้ายที่ทำงาน',
      'ASDF': 'ASDF - ทดองเคลื่อนไหว',
      'HRC': 'HRC - HRC Test',
      'TG': 'TG - test01'
    }

    return {
      codmov: {
        en: mockCodmov,
        th: mockCodmov
      }
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word() + ' - ',
      desc_codempid: faker.name.findName(),
      numseq: faker.random.number().toString().substr(0, 1),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      dteeffec: moment().format('DD/MM/YYYY'),
      codmov: faker.lorem.word(),
      desc_codmov: faker.lorem.word(),
      status: faker.lorem.words(),
      remark: faker.lorem.words(),
      codappr: faker.lorem.word(),
      staappr: ''
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres35u/mocker.js